import { AlertOverview } from "types/portfolio";
import { CSSProperties, ReactNode } from "react";
import { GridReadyEvent } from "ag-grid-community";

export const ALERT_ICON_TYPE = [
  "USAGE",
  "CHURN_RISK",
  "SUPPORT",
  "HEALTH",
  // "AEM_WEM",
] as const;

export type AlertIconType = (typeof ALERT_ICON_TYPE)[number];

export interface AlertIconProps extends SharedCallbackProps {
  type: AlertIconType;
  accountKey?: string;
}

export interface AlertDetail {
  createdDate: string;
  createdBy: string;
  lastModifiedDate: string;
  lastModifiedBy: string;
  id: string;
  category: string;
  type: AlertIconType;
  accountKey: string;
  accountId: string;
  accountName: string;
  referenceId: string;
  name: string;
  description: string;
  swssAccountTypeIndicator: null | string;
  status: string;
  dismissed: boolean; // whether dismiss or not
  noteId: string;
  changeRate: number;
  subscriptionId: null | string;
  renewDate: null | string;
  currORA: null | string;
  preORA: null | string;
}

export interface AlertIconListViewConfig<T> {
  label: string;
  colId: keyof T;
  valueFormatter?: (value: string, data: T) => ReactNode;
  valueStyle?: CSSProperties | ((value: string) => CSSProperties);
  tooltip?: ReactNode;
}

export const TYPE_TO_VALUE_KEY_MAPPING: {
  [key in AlertIconType]: keyof AlertOverview;
} = {
  USAGE: "usageCount",
  CHURN_RISK: "churnRiskCount",
  SUPPORT: "supportCount",
  HEALTH: "healthCount",
  // AEM_WEM: "aemCount",
};

/**
 * @param if alertId is passed, then dismiss one
 */
export interface DismissPayload {
  alertId?: string;
  accountKeys: string[];
  alertType: AlertIconType;
  dismissAllCount?: number;
}

/**
 * @param gridEvent - only when need to update the grid, pass gridEvent
 * @param mutateKeys - pass the mutate keys that need to update, apply to use the same type AlertOverview
 */
export interface SharedCallbackProps {
  gridEvent?: GridReadyEvent;
  mutateKeys?: string[];
  accountLevelMutateKeys?: string[];
}

export interface DismissCallbackProps extends SharedCallbackProps {
  payload: DismissPayload;
}
